import get from "lodash/get";
import React from "react";
import activities from "./activities";
import logEvent from "src/utils/logEvent";

type ConundrumDisplayRendererProps = {
  params: {
    conundrumName: string;
    stepName: string;
  };
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class ConundrumDisplayRenderer extends React.Component<ConundrumDisplayRendererProps> {
  componentDidMount() {
    const { conundrumName, stepName } = this.props.params;
    logEvent({
      eventName: `conundrums.${conundrumName}.${stepName}`,
    });
  }

  render() {
    const {
      params: { conundrumName, stepName },
    } = this.props;
    const definition = activities[conundrumName];
    const index = parseInt(stepName, 10);
    const Slide = get(definition, [index, "display"]);
    if (!Slide) {
      return <div>{`Couldn't find slide for ${conundrumName} ${index} (display)`}</div>;
    }
    return <Slide />;
  }

  UNSAFE_componentWillReceiveProps(nextProps: ConundrumDisplayRendererProps) {
    const params = this.props.params;
    const nextParams = nextProps.params;
    // log event if slide has changed
    if (nextParams.conundrumName !== params.conundrumName || nextParams.stepName !== params.stepName) {
      logEvent({
        eventName: `conundrums.${nextParams.conundrumName}.${nextParams.stepName}`,
      });
    }
  }
}
